module.exports = __webpack_public_path__ + "fonts/3MCircularTT-Bold.49411b15.ttf";